// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BulkEditFields_TliFragmentDoc } from '../../../../plan-package/takeoffs/components/BulkEditFields.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TakeoffsBulkEditPanel_GetTlisQueryVariables = Types.Exact<{
  filter: Types.TakeoffLineItemFilter;
  versionId: Types.Scalars['ID']['input'];
}>;


export type TakeoffsBulkEditPanel_GetTlisQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', id: string, costType: Types.CostType, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, canEditLocation: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } };


export const TakeoffsBulkEditPanel_GetTlisDocument = gql`
    query TakeoffsBulkEditPanel_GetTlis($filter: TakeoffLineItemFilter!, $versionId: ID!) {
  takeoffLineItemsPage(filter: $filter, versionId: $versionId) {
    items {
      id
      ...BulkEditFields_Tli
      item {
        id
        costCode {
          id
          displayName
        }
      }
    }
  }
}
    ${BulkEditFields_TliFragmentDoc}`;

/**
 * __useTakeoffsBulkEditPanel_GetTlisQuery__
 *
 * To run a query within a React component, call `useTakeoffsBulkEditPanel_GetTlisQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakeoffsBulkEditPanel_GetTlisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakeoffsBulkEditPanel_GetTlisQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useTakeoffsBulkEditPanel_GetTlisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TakeoffsBulkEditPanel_GetTlisQuery, TakeoffsBulkEditPanel_GetTlisQueryVariables> & ({ variables: TakeoffsBulkEditPanel_GetTlisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TakeoffsBulkEditPanel_GetTlisQuery, TakeoffsBulkEditPanel_GetTlisQueryVariables>(TakeoffsBulkEditPanel_GetTlisDocument, options);
      }
export function useTakeoffsBulkEditPanel_GetTlisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TakeoffsBulkEditPanel_GetTlisQuery, TakeoffsBulkEditPanel_GetTlisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TakeoffsBulkEditPanel_GetTlisQuery, TakeoffsBulkEditPanel_GetTlisQueryVariables>(TakeoffsBulkEditPanel_GetTlisDocument, options);
        }
// @ts-ignore
export function useTakeoffsBulkEditPanel_GetTlisSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsBulkEditPanel_GetTlisQuery, TakeoffsBulkEditPanel_GetTlisQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TakeoffsBulkEditPanel_GetTlisQuery, TakeoffsBulkEditPanel_GetTlisQueryVariables>;
export function useTakeoffsBulkEditPanel_GetTlisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsBulkEditPanel_GetTlisQuery, TakeoffsBulkEditPanel_GetTlisQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TakeoffsBulkEditPanel_GetTlisQuery | undefined, TakeoffsBulkEditPanel_GetTlisQueryVariables>;
export function useTakeoffsBulkEditPanel_GetTlisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsBulkEditPanel_GetTlisQuery, TakeoffsBulkEditPanel_GetTlisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TakeoffsBulkEditPanel_GetTlisQuery, TakeoffsBulkEditPanel_GetTlisQueryVariables>(TakeoffsBulkEditPanel_GetTlisDocument, options);
        }
export type TakeoffsBulkEditPanel_GetTlisQueryHookResult = ReturnType<typeof useTakeoffsBulkEditPanel_GetTlisQuery>;
export type TakeoffsBulkEditPanel_GetTlisLazyQueryHookResult = ReturnType<typeof useTakeoffsBulkEditPanel_GetTlisLazyQuery>;
export type TakeoffsBulkEditPanel_GetTlisSuspenseQueryHookResult = ReturnType<typeof useTakeoffsBulkEditPanel_GetTlisSuspenseQuery>;
export type TakeoffsBulkEditPanel_GetTlisQueryResult = ApolloReactCommon.QueryResult<TakeoffsBulkEditPanel_GetTlisQuery, TakeoffsBulkEditPanel_GetTlisQueryVariables>;